/**
 * The rotation component defines the orientation of an entity in degrees.
 * It takes the pitch (x), yaw (y), and roll (z) as three space-delimited numbers
 * indicating degrees of rotation.
 *
 * All entities inherently have the rotation component.
 *
 * @see https://aframe.io/docs/1.3.0/components/rotation.html
 */
export var Rotation = function Rotation(_ref) {
  var _this = this;

  var x = _ref.x,
      y = _ref.y,
      z = _ref.z;

  this.toString = function () {
    return _this.x + " " + _this.y + " " + _this.z;
  };

  this.x = x;
  this.y = y;
  this.z = z;
};